import React from 'react';
import { motion } from 'framer-motion';
import { DownloadIcon, SparklesIcon } from 'lucide-react';
export function PricingCTA() {
  return <section id="comprar" className="w-full bg-gradient-to-b from-cream-200 via-gold-100 to-cream-100 py-20 md:py-28 px-4" data-id="element-95">
      <div className="max-w-3xl mx-auto text-center" data-id="element-96">
        <motion.div initial={{
        opacity: 0,
        y: 40
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.7
      }} data-id="element-97">
          <SparklesIcon className="w-12 h-12 text-gold-500 mx-auto mb-6" data-id="element-98" />

          <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl text-brown-700 mb-6" data-id="element-99">
            Tu guía completa te espera
          </h2>

          <div className="inline-flex items-center gap-3 bg-white px-8 py-4 rounded-full shadow-lg mb-4" data-id="element-100">
            <span className="text-2xl text-brown-400 line-through" data-id="element-101">
              USD $19
            </span>
            <span className="text-4xl md:text-5xl font-bold text-gold-600" data-id="element-102">
              USD $6
            </span>
          </div>

          <p className="text-sm text-red-500 font-semibold mb-8" data-id="element-103">
            🔥 Oferta por tiempo limitado — 68% de descuento
          </p>

          <p className="text-lg text-brown-600 mb-4 max-w-xl mx-auto" data-id="element-104">
            Una guía completa, práctica y directa para volver a vos y manifestar
            con coherencia.
          </p>

          <p className="text-brown-500 mb-8 flex items-center justify-center gap-2" data-id="element-105">
            <DownloadIcon className="w-5 h-5 text-gold-500" data-id="element-106" />
            Acceso: descarga inmediata del PDF
          </p>

          <motion.a href="https://www.escueladigitallidera.com//cart/48324707025115:1" target="_blank" rel="noopener noreferrer" whileHover={{
          scale: 1.05
        }} whileTap={{
          scale: 0.98
        }} className="inline-flex items-center gap-3 bg-gradient-to-r from-gold-500 to-gold-600 text-white font-bold text-xl px-12 py-5 rounded-full shadow-2xl shadow-gold-500/40 hover:shadow-gold-500/60 transition-shadow duration-300" data-id="element-107">
            <SparklesIcon className="w-6 h-6" data-id="element-108" />
            Quiero mi PDF ahora
          </motion.a>

          <p className="mt-6 text-sm text-brown-400" data-id="element-109">
            O su equivalente en pesos argentinos al tipo de cambio del día
          </p>
        </motion.div>

        {/* Author credit */}
        <motion.div initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6,
        delay: 0.3
      }} className="mt-16 pt-8 border-t border-gold-200" data-id="element-110">
          <p className="text-brown-500" data-id="element-111">
            Creado con amor por{' '}
            <span className="font-semibold text-brown-700" data-id="element-112">
              Rebeca Rodriguez
            </span>
          </p>
        </motion.div>
      </div>
    </section>;
}